import { Box, Typography } from "@mui/material"
import { useGridApiRef } from "@mui/x-data-grid";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Localozation from "../components/Localisation";
import { setDate } from "../store/vendorSlice";
import { documentVendorProductsEditAction } from "../asyncActions/vendorActions";
import { useTranslation } from "react-i18next";
import DataGridFullScreen from "../components/DataGridFullScreen";
import { wasteDocumentProductAction } from "../asyncActions/documentActions";



function WasteListPage() {

    const dispatch = useDispatch()

    const { t } = useTranslation()

    const apiRef = useGridApiRef()

    const {
        dateFilter,
        dataLoad,
        productWasteList,
    } = useSelector(store => store.vendor)

    const {
        role
    } = useSelector(store => store.authorization)


    const {
        postLoad
    } = useSelector(store => store.postLoad)

    useEffect(() => {
        dispatch(wasteDocumentProductAction(dateFilter.date))
    }, [dateFilter.date])

    const rows = productWasteList.map(elem => ({
        id: elem.id,
        product: elem.product.name,
        unit_type: elem.product.unit_type,
        quantity: +elem.quantity,
    }))

    const columns = [
        {
            field: 'id',
            headerName: 'id',
            maxWidth: 80,
        },
        {
            field: 'product',
            headerName: t('grid.product_name'),
            minWidth: 180,
            flex: 1
        },
        {
            field: 'unit_type',
            headerName: t('grid.unit_type'),
            maxWidth: 80,
        },
        {
            field: 'quantity',
            headerName: t('grid.qnt'),
            editable: role === 5,
            type: 'number',
            minWidth: 100,
            flex: 1
        }
    ];

    const handleCellClick = useCallback((params) => {
        try {
            apiRef.current.startCellEditMode({
                id: params.id,
                field: params.field,
            })
        } catch (e) {
        }
    },
        [apiRef],
    );


    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 5,
            height: '100%',
            width: '100%'
        }}>
            <Typography variant="h4">Waste product list</Typography>
            <Localozation>
                <DatePicker
                    disabled={dataLoad}
                    label={t('label.document_date')}
                    format="YYYY-MM-DD"
                    value={dateFilter.date}
                    onChange={(date) => {
                        dispatch(setDate(date))
                    }}
                />
            </Localozation>
            <Box sx={{ width: '100%', height: '100%' }}>
                <DataGridFullScreen
                    apiRef={apiRef}
                    columns={columns}
                    rows={rows}
                    loading={dataLoad || postLoad}
                    showCellVerticalBorder
                    hideFooter
                    handleCellClick={handleCellClick}
                />
            </Box>
            {/* <StyledModal /> */}
        </Box>
    )
}

export default WasteListPage


